import { Box, Input, Select, MenuItem } from "@mui/material";
import { FC } from "react";
import { IProforma } from "../../../interfaces/IProforma";

interface ZkZdStatusComponentProps {
    zk: string;
    zd: string;
    status: IProforma['status'];
    setZk: (zk: string) => void;
    setZd: (zd: string) => void;
    setStatus: (status: IProforma['status']) => void;
}

const statusOrder: IProforma['status'][] = [
    "awaiting_adv",
    "adv_paid",
    "sent",
    "received",
    "cancelled"
];

const statusLabels: Record<IProforma['status'], string> = {
    awaiting_adv: "Oczekuje na zaliczkę",
    adv_paid: "Zaliczka opłacona",
    sent: "Wysłane",
    received: "Odebrane",
    cancelled: "Anulowane"
};

const ZkZdStatusComponent: FC<ZkZdStatusComponentProps> = ({
    zk,
    zd,
    status,
    setZk,
    setZd,
    setStatus,
}) => {
    return (
        <Box sx={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            mt: 8,
        }}>
            <Box sx={{
                boxShadow: 5,
                width: "100%",
                maxWidth: '1086px',
                p: 4,
                borderRadius: 3,
                display: "flex",
                justifyContent: "space-between",
            }}>
                <Box sx={{ width: "30%", mt:3 }}>
                    <Box sx={{ mb: 1, color: "text.secondary", fontSize: 14 }}>ZK</Box>
                    <Input
                        fullWidth
                        value={zk}
                        onChange={(e) => setZk(e.target.value)}
                        placeholder="ZK"
                    />
                </Box>
                <Box sx={{ width: "30%", mt:3 }}>
                    <Box sx={{ mb: 1, color: "text.secondary", fontSize: 14 }}>ZD</Box>
                    <Input
                        fullWidth
                        value={zd}
                        onChange={(e) => setZd(e.target.value)}
                        placeholder="ZD"
                    />
                </Box>
                <Box sx={{ width: "30%" }}>
                    <Box sx={{ mb: 1, color: "text.secondary", fontSize: 14 }}>Status</Box>
                    <Select
                        fullWidth
                        value={status}
                        onChange={e => setStatus(e.target.value as IProforma['status'])}
                        displayEmpty
                    >
                        {statusOrder.map((stat) => (
                            <MenuItem key={stat} value={stat}>
                                {statusLabels[stat]}
                            </MenuItem>
                        ))}
                    </Select>
                </Box>
            </Box>
        </Box>
    )
}

export default ZkZdStatusComponent;